import cartFunctions from './cartFunctions';

export default {
  functions: [
    ...cartFunctions,
    {
      name: 'getPPProducts',
      type: 'angularData',
      options: {
        source: 'appExtensionSdkData',
        key: 'ppProducts',
      },
    },
  ],
};
